import SubscriptionPlan, {
  SubscriptionBillingType,
} from "@/models/subscription/SubscriptionPlan";
import store from "@/state/store";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class FunctionalityLimitationMixin extends Vue {
  // 📦 The current subscription plan the user is on
  private get currentSubscriptionPlan(): SubscriptionPlan {
    return store.state.subscription.currentSubscriptionPlan;
  }

  // 🚩 Flag for whether the user is on the admin plan
  public get isAdminUser(): boolean {
    return (
      this.currentSubscriptionPlan != null &&
      this.currentSubscriptionPlan != undefined &&
      this.currentSubscriptionPlan.billingType ===
      SubscriptionBillingType.Free &&
      this.currentSubscriptionPlan.type === "Admin"
    );
  }

  // 🚩 Flag for whether the user is on the admin or lifetime plans
  public get isPremiumAccessUser(): boolean {
    return (
      this.currentSubscriptionPlan != null &&
      this.currentSubscriptionPlan != undefined &&
      this.currentSubscriptionPlan.billingType ===
      SubscriptionBillingType.Free &&
      (this.currentSubscriptionPlan.type === "Admin" || this.currentSubscriptionPlan.type.includes("Lifetime Plus"))
    );
  }
}
